var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlesh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 66,
    viewBox: "0 0 83 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_212_570)",
    filter: "url(#filter0_d_212_570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4018 52.9345C31.3439 49.0397 40.5941 40.4443 49.4854 31.5468C58.3767 22.6492 66.4511 13.1259 68.3893 -0.00474964C68.8259 2.98593 67.4329 9.13248 65.3723 12.917C55.9377 30.2658 42.5701 43.7166 25.0742 53.0605C24.952 53.1061 24.8992 53.28 24.5982 53.6636L40.2219 54.1285C38.7488 55.157 37.4288 54.8467 36.2133 54.859C30.3616 54.9532 24.5692 55.206 18.7917 56.2298C17.2455 56.5759 15.7178 57.0005 14.2147 57.5022C13.2473 57.7781 11.6497 58.215 11.9282 56.9251C12.1709 55.7974 10.7085 53.6576 13.2194 53.316C13.8002 53.2375 14.3331 53.246 14.8069 52.766C18.774 48.7272 23.3711 45.3148 26.9568 40.8706C27.891 39.7029 28.6526 38.4028 29.4874 37.1553C29.8558 36.6082 30.1598 35.8885 31.0178 36.3234C31.8759 36.7583 31.6149 37.4354 31.4589 38.0786C30.9465 40.1897 29.5909 41.7913 28.0811 43.2376C25.4899 45.7152 22.8099 48.0983 20.1971 50.5467C19.5706 51.1049 18.798 51.5156 18.4018 52.9345Z",
    fill: "#656565"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_212_570",
    x: -4,
    y: 0,
    width: 90.7285,
    height: 71.9392,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_212_570"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_212_570",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_212_570"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 41,
    fill: "white",
    transform: "translate(82.7285 38.4114) rotate(159.531)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlesh);
export default __webpack_public_path__ + "static/media/flesh.df7e7dfad7782442818c116d2a107ded.svg";
export { ForwardRef as ReactComponent };